import { render, staticRenderFns } from "./jobPayrollHeader.vue?vue&type=template&id=5daa18fb&scoped=true"
import script from "./jobPayrollHeader.vue?vue&type=script&lang=js"
export * from "./jobPayrollHeader.vue?vue&type=script&lang=js"
import style0 from "./jobPayrollHeader.vue?vue&type=style&index=0&id=5daa18fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daa18fb",
  null
  
)

export default component.exports